import { jsx as _jsx } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import { useDataProps, useAriaProps } from '@famly/mf_ts-utils_data-aria-props';
import { extractSystemStyles } from '@famly/mf_system_system-props';
/**
 * Spinner component based on MUI CircularProgress
 * Used to indicate a loading state
 *
 * @param props - The component props
 * @returns A spinner component
 *
 * @example
 * ```tsx
 * <Spinner aria-label={i18next.t("mf.feedback_spinner.src.translations.json.loadingCalendar")} />
 * ```
 */
export const Spinner = (props) => {
    const { size = 24, color, ...rest } = props;
    const dataProps = useDataProps(rest);
    const ariaProps = useAriaProps(rest);
    const { sx } = extractSystemStyles({ ...rest, color: color !== null && color !== void 0 ? color : 'p300' });
    return _jsx(CircularProgress, { ...dataProps, ...ariaProps, size: size, sx: sx });
};
